import { globalState } from '@codeleap/store'

/**
 * Where to go once this sign-in finishes, when it is somewhere other than the feed.
 *
 * Two callers ask for it: a `?next=` on the login URL, and the unsubscribe screen, which
 * sends people to their settings. It used to be a prop threaded from the page into the form
 * and applied there, which meant only the e-mail path honoured it — a social sign-in from
 * the same screen landed somewhere else.
 *
 * Outside the machine's state on purpose: it is set before signing in starts and read after
 * it ends, so it has to survive every reset in between. Taking it clears it, so it cannot
 * redirect a later, unrelated sign-in. See EPIC-005.
 */
const store = globalState<{ next: string | null }>({ next: null })

export const landing = {
  set: (next: string | null) => store.set({ next }),

  take: () => {
    const next = store.get().next

    if (next) store.set({ next: null })

    return next
  }
}
